<template>
  <div class="my-6">
    <scale-notification
      v-if="props.show"
      :opened="props.show"
      :variant="props.variant"
      :heading="props.title"
      :dismissible="props.variant === 'success' ? false : true"
    >
      <div slot="text">
        <p class="ma-0" v-for="(textLine, index) in props.text" :key="index">
          {{ textLine }}
        </p>
      </div>
    </scale-notification>
  </div>
</template>

<script setup>
/**
 * @vuese
 * VNotification component is used to display a quick message (success, error, etc.) to a user.
 * The component uses the Scale `<scale-notification>` component as the basis,
 * but applies an app-specific style and conventions.
 */
import { defineProps } from 'vue';

const props = defineProps({
  // Show notification component
  show: { type: Boolean, required: true, default: false },
  // Notification title
  title: { type: String, required: true },
  // Notification text
  text: { required: false },
  // Notification variant ("error", "success" or "informational")
  variant: {
    type: String,
    validator(value) {
      return ["danger", "success", "informational"].includes(value);
    },
    default: "informational",
  },
});
</script>
